// extracted by css-extract-rspack-plugin
export default {"link":"_b94ff814"};